// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__23Mv5","head":"Table_head__1AlDv","col":"Table_col__e7wzm"};